export default {
  labels: {
    card: 'Carte de crédit',
    bank_account: 'Compte bancaire',
  },
  alerts: {
    payments_not_configured:
      'Les paiements ne sont pas encore configurés. Veuillez contacter votre fournisseur pour les activer, puis revenez à cette étape.',
  },
  buttons: {
    change_payment_method: 'Changer de mode de paiement',
    save_payment_info: 'Enregistrer les infos de paiement',
  },
  toasts: {
    failed_to_init_payment_setup: "Échec de l'initialisation du paiement, veuillez recharger la page",
    successfully_saved_payment_method: 'Informations de paiement enregistrées',
  },
};
